<template>
	<div class="total-level-analysis">
		<div style="font-weight: bold; font-size: 18px">
			<span>等级分析</span>
		</div>
		<div class="total-grade" v-for="(item, index) in gradeRateDataArr" :key="index">
			<div class="subGra-title">
				<div class="grade-title">
					<!-- <span>等级分析</span> -->
					<!-- <div class="Ranking-rate">
						<el-button type="" :class="RankFlag ? 'current' : ''" size="mini" @click="ImproRankClick">分数</el-button>
						<el-button type="" :class="RankFlag ? '' : 'current'" size="mini" @click="ImproRateClick">比例</el-button>
					</div> -->
					<!-- <el-select v-model="subject" size="mini" placeholder="请选择" @change="newChageSelect">
						<el-option v-for="item in subjectData" :key="item.pkId" :label="item.subName" :value="item.pkId"> </el-option>
					</el-select> -->
				</div>
			</div>
			<div class="subGra-level">
				<span>按{{ item.level }}分析</span>
			</div>
			<p>
				<span>以A，B，C...为等级对参考班级或学校分析</span>
				<span>科目：{{ item.subName }}</span>
			</p>
			<div class="subGradeRate-table">
				<tables :tableOptions="item.gradeLevelSturcture"></tables>
			</div>
			<!-- <div class="subGradeRate-table" v-for="(newItem, newIndex) in subjecketArr" :key="newIndex">
				<tables :tableOptions="newItem.gradeLevelSturcture"></tables>
			</div> -->
		</div>
	</div>
</template>

<script>
export default {
	components: {
		tables: () => import('hm-table')
	},
	data() {
		return {
			type: '2',
			RankFlag: true,
			subject: '',
			subjectData: [],
			gradeLevelSturcture: [],
			level: '',
			gradeRateArr: [],
			gradeRateDataArr: [],
			subjecketArr: [],
			query: this.$route.query
		}
	},
	created() {
		this.getNewSubjectData()
		// this.getLevelStructure()
		this.getGradeRataData()
		// this.getNewLevelStructure()
	},
	methods: {
		getNewSubjectData(subjeckId) {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				examSubjectId: subjeckId
			}
			this.$post( 'reportApi/selectThreeRateAnalyseList', params).then(res => {
				this.newTableData = res.data.data
				this.subjectData = res.data.subjectList
				this.newSubject = res.data.examSubjectId
			})
		},
		getLevelStructure(type, level, subName, subjeckId) {
			this.gradeRateDataArr = []
			this.subjecketArr = []
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: type,
				examSubjectId: subjeckId
			}
			this.$post( 'reportApi/selectLevelReportList', params).then(res => {
				let levelObj = {}
				this.gradeLevelSturcture = res.data.data
				this.subject = res.data.examSubjectId
				this.level = level
				levelObj.level = level
				levelObj.subName = subName
				levelObj.gradeLevelSturcture = this.gradeLevelSturcture
				this.gradeRateDataArr.push(levelObj)
			})
		},
		getGradeRataData() {
			this.gradeRateArr = [
				{ level: '分数', type: '2' },
				{ level: '比例', type: '1' }
			]
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId
				// examSubjectId: subjeckId
			}
			this.$post( 'reportApi/selectThreeRateAnalyseList', params).then(res => {
				this.newTableData = res.data.data
				this.subjectData = res.data.subjectList
				this.newSubject = res.data.examSubjectId
				// console.log(this.subjectData)
				this.gradeRateArr.forEach(item => {
					this.type = item.type
					this.level = item.level
					this.subjectData.forEach(newItem => {
						this.getLevelStructure(this.type, this.level, newItem.subName, newItem.pkId)
					})
					// this.getLevelStructure(this.type, this.level)
				})
			})
		},
		//分数
		ImproRankClick() {
			this.RankFlag = true
			this.type = '2'
			this.getLevelStructure(this.type, this.subject)
		},
		//比例
		ImproRateClick() {
			this.RankFlag = false
			this.type = '1'
			this.getLevelStructure(this.type, this.subject)
		},
		//选择科目
		newChageSelect() {
			this.getLevelStructure(this.type, this.subject)
		}
	}
}
</script>

<style lang="less" scoped>
.current {
	background-color: #009688;
	color: #fff;
	border: 1px solid #009688;
}
.total-level-analysis {
	height: auto;
	background-color: #fff;
	margin: 10px 0px;
	padding: 30px;
	border: 1px solid #ebeef5;
	// background-color: #fff;
	color: #303133;
	-webkit-transition: 0.3s;
	transition: 0.3s;
	border-radius: 4px;
	overflow: hidden;
	&:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
	.sub-test-test-cont {
		height: auto;
		.subTest-title {
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			box-sizing: border-box;
			> span {
				font-size: 18px;
				color: #333;
				margin-right: 20px;
				flex-grow: 1;
			}
			/deep/.el-select {
				width: 100.36px;
			}
		}
	}
	.subject-grade-rate,
	.total-grade {
		height: auto;
		> p {
			display: flex;
			justify-content: space-between;
			font-size: 13px;
			margin-top: 15px;
			margin-bottom: 10px;
		}
		.subGra-title {
			display: flex;
			height: auto;
			align-items: center;
			margin-bottom: 5px;
			.grade-title {
				> span {
					font-weight: bold;
					font-size: 18px;
				}
				height: auto;
				margin: 5px 0;
				display: flex;
				flex-grow: 1;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				box-sizing: border-box;
				margin-right: 10px;
				// > span {
				// 	flex-grow: 1;
				// }
				/deep/.el-button + .el-button {
					margin-left: 0;
				}
				/deep/.el-button:hover {
					color: #fff;
					background-color: #009688;
				}
			}
		}
		.subGra-level {
			font-size: 15px;
			font-weight: bold;
		}
	}
	.total-grade {
		height: auto;
		margin-top: 0;
		/deep/.el-select {
			width: 100.36px;
		}
	}
}
</style>
